"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _Pill = _interopRequireDefault(require("../../Pill/Pill"));
var _Countdown = _interopRequireDefault(require("../../Countdown/Countdown"));
var _Modal = _interopRequireDefault(require("../../Modal"));
var _Toggle = _interopRequireDefault(require("../../helpers/Toggle"));
var _buttons = require("../../constants/buttons");
var _Card = _interopRequireDefault(require("../../Card/Card"));
var _constants = require("../../constants");
var _envConstants = require("../../../env-constants");
var Basic = function Basic(_ref) {
  var bgImage = _ref.bgImage,
    _ref$overlay = _ref.overlay,
    overlay = _ref$overlay === void 0 ? true : _ref$overlay,
    title = _ref.title,
    subtitle = _ref.subtitle,
    topText = _ref.topText,
    whiteFont = _ref.whiteFont,
    _ref$cta = _ref.cta,
    cta = _ref$cta === void 0 ? {
      text: ''
    } : _ref$cta,
    _ref$cta2 = _ref.cta2,
    cta2 = _ref$cta2 === void 0 ? {
      text: ''
    } : _ref$cta2,
    countdown = _ref.countdown,
    inView = _ref.inView,
    centeredDesktop = _ref.centeredDesktop,
    modalVideoLink = _ref.modalVideoLink,
    whiteSideOverlay = _ref.whiteSideOverlay,
    whiteOverlay = _ref.whiteOverlay,
    logo = _ref.logo,
    trailerLink = _ref.trailerLink,
    pill = _ref.pill,
    signUpForm = _ref.signUpForm,
    addressBookId = _ref.addressBookId,
    hideLastName = _ref.hideLastName;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hero--basic padding-top-md padding-top-0@md d8-u-bg-img d8-u-relative",
    role: "img",
    "aria-label": bgImage.alt || bgImage.title,
    style: {
      backgroundImage: "url(".concat(inView ? bgImage.url : '', ")")
    }
  }, overlay && /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-overlay ".concat(whiteSideOverlay && 'white-side', " ").concat(whiteOverlay && 'white')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "container max-width-lg flex items-center height-100% d8-u-relative"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(centeredDesktop && 'hero-center margin-auto@sm text-center@sm', 'basic-content__wrapper text-component margin-top-auto margin-right-auto margin-bottom-auto')
  }, logo && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex margin-bottom-sm"
  }, logo), pill && pill.text && /*#__PURE__*/_react["default"].createElement(_Pill["default"], {
    type: "pill--black",
    title: pill.text
  }), topText && /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('text-sm', 'd8-u-ls-sm', 'd8-u-text-uppercase', whiteFont && 'd8-u-color-white')
  }, topText), title && /*#__PURE__*/_react["default"].createElement("h1", {
    className: (0, _classnames["default"])(whiteFont && 'd8-u-color-white', 'text-xxxl'),
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), subtitle && /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _classnames["default"])('subtitle', 'max-width-xxxs', 'text-md', whiteFont && 'd8-u-color-white', 'margin-top-md')
  }, subtitle), countdown && /*#__PURE__*/_react["default"].createElement(_Countdown["default"], {
    countdown: countdown
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-wrap"
  }, trailerLink && /*#__PURE__*/_react["default"].createElement(_Toggle["default"], null, function (_ref2) {
    var on = _ref2.on,
      toggle = _ref2.toggle;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "margin-top-md margin-right-sm"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      text: "Play the video",
      buttonType: _buttons.BUTTON_TYPES.WHITE,
      onClick: toggle,
      icon: "play",
      iconFlip: true,
      buttonSize: _buttons.BUTTON_SIZES.MEDIUM
    }), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
      toggle: toggle,
      on: on,
      template: "Video",
      video: trailerLink
    }));
  }), signUpForm && /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-md"
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    template: "ImageCard",
    signUp: true,
    hideLastName: hideLastName,
    addressBookId: addressBookId || _constants.ADDRESS_BOOKS["".concat(_envConstants.ENV.SITE, "-footer")],
    imageCardTemplate: "SignUp",
    whiteFont: true,
    bgColor: "transparet",
    size: "auto",
    style: {
      boxShadow: 'none',
      padding: '0px',
      margin: '0px'
    }
  }))), cta.text && !signUpForm && !modalVideoLink && /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-md margin-right-sm"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    buttonSize: _buttons.BUTTON_SIZES.MEDIUM,
    text: cta.text,
    buttonType: _buttons.BUTTON_TYPES.PRIMARY,
    icon: cta.icon,
    iconFlip: cta.iconFlip,
    link: cta.link,
    onClick: cta.onClick,
    external: cta.external
  })), cta2.text && !modalVideoLink && /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-md margin-right-sm"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "margin-left-sm",
    text: cta2.text,
    buttonType: _buttons.BUTTON_TYPES.SECONDARY,
    buttonSize: _buttons.BUTTON_SIZES.MEDIUM,
    icon: cta2.icon,
    iconFlip: cta2.iconFlip,
    onClick: cta2.onClick,
    link: cta2.link,
    external: cta2.external
  }))), cta.text && modalVideoLink && /*#__PURE__*/_react["default"].createElement(_Toggle["default"], null, function (_ref3) {
    var on = _ref3.on,
      toggle = _ref3.toggle;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "margin-top-md"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      text: cta.text,
      buttonType: _buttons.BUTTON_TYPES.WHITE,
      onClick: toggle,
      icon: cta.icon,
      iconFlip: cta.iconFlip
    }), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
      toggle: toggle,
      on: on,
      template: "Video",
      video: modalVideoLink
    }));
  }))));
};
Basic.propTypes = {
  bgImage: _propTypes["default"].object,
  title: _propTypes["default"].string,
  subtitle: _propTypes["default"].string,
  topText: _propTypes["default"].string,
  whiteFont: _propTypes["default"].bool,
  overlay: _propTypes["default"].bool,
  inView: _propTypes["default"].bool,
  cta: _propTypes["default"].object,
  cta2: _propTypes["default"].object,
  countdown: _propTypes["default"].string,
  centeredDesktop: _propTypes["default"].bool,
  whiteSideOverlay: _propTypes["default"].bool,
  modalVideoLink: _propTypes["default"].string,
  trailerLink: _propTypes["default"].string,
  pill: _propTypes["default"].object,
  logo: _propTypes["default"].node,
  signUpForm: _propTypes["default"].bool,
  hideLastName: _propTypes["default"].bool,
  whiteOverlay: _propTypes["default"].bool,
  addressBookId: _propTypes["default"].string
};
Basic.defaultProps = {
  overlay: true,
  cta: {
    text: ''
  },
  cta2: {
    text: ''
  },
  bgImage: {}
};
var _default = exports["default"] = Basic;